import {CloseOutlined} from "@mui/icons-material";
import {SxProps} from "@mui/system";
import {ReactNode} from "react";
import {Colors, Container, IconButton} from "../../../ui";

export const TooltipContent = ({onClose, children, sx}: {onClose: () => void; children: ReactNode; sx?: SxProps}) => {
  return (
    <Container
      sx={{
        alignItems: "start",
        padding: "4px",
        gap: "4px",
        ...sx,
      }}
    >
      <IconButton
        aria-label="close"
        size="small"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 2,
          right: 2,
          color: Colors.grey._700,
          zIndex: 10,
        }}
      >
        <CloseOutlined sx={{width: "16px", height: "16px"}} />
      </IconButton>
      {children}
    </Container>
  );
};
